import { useEffect } from 'react';
import useAuthStore from '../store/authStore';

export const useAuth = () => {
  const {
    user,
    profile,
    isAdmin,
    session,
    loading,
    initialized,
    initialize,
    signIn,
    signOut,
    refreshAdminStatus
  } = useAuthStore();

  useEffect(() => {
    if (!initialized) {
      initialize();
    }
  }, [initialized, initialize]);

  return {
    user,
    profile,
    isAdmin,
    session,
    loading,
    initialized,
    signIn,
    signOut,
    refreshAdminStatus,
  };
};
